var Core = require('./core');
var NativeCore = require('./native-core');
var Network = require('./network');
var Promise = require('promise');

Core.prototype._mixin(Core.prototype, NativeCore);
Core.prototype._mixin(Core.prototype, Network);
Core.prototype.all = function(list){
	return Promise.all(list);
};
module.exports = Core;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp-core/lib/index.js
// module id = 538
// module chunks = 0